export default "/images/adfd9900e4ae4877f0c4d8180fa4b56e.avif";